import *  as React from 'react';
import { useState, useEffect } from 'react';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { AnimatePresence, motion } from "framer-motion"
import { useAtom, atom } from 'jotai'
import { Sidebar } from "./Sidebar";
import { MainImage } from "./MainImage";

interface HomeProps { }

const ImageAnimation = {
	initial: { x: 0 },
	animate: { x: "150px" },
	exit: { x: 0 },
	transition: { duration: 0.4 },
}

export const Home: React.FC<HomeProps> = (props: React.PropsWithChildren<HomeProps>) => {
	//const [animateImg, setAnimateImg] = useAtom(imgMove);

	const [animateImg, setAnimateImg] = useState(false);
	const handle = useFullScreenHandle();
	const [isEnterFirst, setIsEnterFirst] = useState(true);
	const [isVisible, setIsVisible] = useState(true);

	const handleClick = () => {
		if (isEnterFirst) {
			handle.enter();
		} else {
			handle.exit();
		}
		setIsEnterFirst(!isEnterFirst);
	};

	useEffect(() => {
		let timeout: NodeJS.Timeout;

		const handleMouseMove = () => {
			setIsVisible(true);
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				setIsVisible(false);
			}, 3000); // Adjust the delay as needed
		};

		window.addEventListener('mousemove', handleMouseMove);

		return () => {
			window.removeEventListener('mousemove', handleMouseMove);
			clearTimeout(timeout);
		};
	}, []);

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 500);

		return () => clearTimeout(timer);
	}, []);

	return (<>

		<FullScreen handle={handle} className="main-page">
			{isVisible && <div className="fullscreen-btn" onClick={handleClick}>
				<i className="fa fa-arrows-alt"></i>
			</div>}
			<AnimatePresence mode="wait" initial={false}>
				{animateImg ?
					<motion.div className="main-image" {...ImageAnimation} aria-label="animateImg" key="img">
						<MainImage />
					</motion.div>
					:
					<div className="main-image">
						<MainImage />
					</div>
				}
			</AnimatePresence>
			<Sidebar />
			{isLoading && <div className="download-loading">
				<i className="fas fa-circle-notch fa-spin"></i>
			</div>
			}
		</FullScreen>
	</>);
}